import { render } from "./InventorySection.vue?vue&type=template&id=3ad9c0c2"
import script from "./InventorySection.vue?vue&type=script&lang=js"
export * from "./InventorySection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\actions-runner\\_work\\cims-billing.ui\\cims-billing.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__